import {
  QUIZ_COUNTDOWN_DEFAULT_SECONDS,
  QUIZ_COUNTDOWN_MIN_SECONDS,
  QUIZ_COUNTDOWN_MAX_SECONDS,
} from '@/constant/quizCountdown'

export default {
  key: 'quizCountdownSeconds',
  type: 'number',
  label: 'Length of countdown before answers',
  description: 'Gives players time to read a long question before the answer options show. '
    + 'Used when the quiz countdown is on in your deck. Self-paced quizzes keep 5 seconds.',
  unit: 'seconds',
  default: QUIZ_COUNTDOWN_DEFAULT_SECONDS,
  min: QUIZ_COUNTDOWN_MIN_SECONDS,
  max: QUIZ_COUNTDOWN_MAX_SECONDS,
  group: 'Presenting',
}
